import {ScriptLoaderService} from '../../services/script-loader.service';
import {environment} from '../../../environments/environment.prod';
import { Injectable } from "@angular/core";

const url = 'https://maps.googleapis.com/maps/api/js?key=' + environment.GOOGLE_KEY + '&libraries=geometry,drawing,places,geocoder&callback=__onGoogleLoaded';

@Injectable()
export class GoogleApiLoader {
    loadAPI: Promise<any>;

    constructor() {
        this.loadAPI = new Promise((resolve) => {
            window['__onGoogleLoaded'] = (ev) => {
                resolve(window);
            };
            this.loadScript();
        });

    }

    LoadAPi() {
        return this.loadAPI;
    }

    private loadScript() {
        const _script = new ScriptLoaderService();
        _script.load('head', url);
    }
}
